import { UI } from '@leverege/ui-redux';
import { Project } from '@leverege/api-redux';
import P from '@leverege/promise';
import I18N from '@leverege/i18n';
import merge from 'deepmerge';
import { I18NBlueprintModel, I18NSystemModel } from '@leverege/api-ui-i18n-management';
import Constants from "../Constants.js";
import MoltenUtil from "../MoltenUtil.js";
import BlueprintAnalyzer from "./BlueprintAnalyzer.js";
export default {
  id: 'molten.BlueprintAnalyzer',
  sort: -1,
  onLoggedIn: async molten => {
    const api = molten.get('api');
    const store = molten.get('store');
    const uiName = molten.getConfig('uiName', 'ui');
    const state = store.getState();
    const prjId = api.options.projectId;
    const sysId = api.options.systemId;
    const activePersona = UI.get(state).activePersona?.name;
    const roles = activePersona ? [activePersona, 'user'] : ['user'];
    const networks = await api.project(prjId).networks().list();
    const bps = Project(prjId).blueprints().getBlueprints(state);
    await initI18N(bps, {
      api,
      uiName,
      projectId: prjId,
      systemId: sysId,
      molten
    });
    const ba = new BlueprintAnalyzer({
      blueprints: bps,
      molten,
      networks: networks.items,
      roles
    });
    await ba.install();
    await MoltenUtil.invokeMoltenCallbacks(Constants.BLUEPRINTS_PROCESSOR, 'processBlueprints', molten, ba.blueprints, {
      networks: networks.items
    });
  }
};
async function initI18N(blueprints, {
  api,
  uiName,
  projectId,
  systemId,
  molten
}) {
  const systemResources = await api.system(systemId).resource('i18n').get({
    children: true
  }).then(res => {
    return res.items.length > 0 ? res.items.filter(item => item.path === 'i18n' || item.path === `i18n/${uiName}`).sort((itemA, itemB) => {
      if (itemA.path === 'i18n') {
        return -1;
      }
      return 1;
    }) : [];
  }).catch(err => {
    console.error(err);
    return [];
  });
  const blueprintResources = await P.map(blueprints, bp => {
    return api.project(projectId).blueprint(bp.id).resource('i18n').get({
      children: true
    }).then(res => {
      return res.items.length > 0 ? res.items.filter(item => item.path === 'i18n' || item.path === `i18n/${uiName}`).sort((itemA, itemB) => {
        if (itemA.path === 'i18n') {
          return -1;
        }
        return 1;
      }) : null;
    }).catch(err => {
      console.error(err);
      return null;
    });
  });
  const mergedSystemResources = systemResources.reduce((prev, value) => {
    return merge(prev, I18NSystemModel.getTranslationData(value.data));
  }, {});
  let mergedBPResources = blueprintResources.reduce((prev, value) => {
    if (value != null) {
      const v = value.reduce((p, c) => {
        return merge(p, I18NBlueprintModel.getTranslationData(c.data));
      }, {});
      prev.push(v);
    }
    return prev;
  }, []);
  mergedBPResources = mergedBPResources.reduce((prev, curr) => {
    return merge(curr, prev);
  }, {});
  const config = molten.getConfig('i18n', {});
  const options = {
    ...config,
    options: {
      ...config?.options,
      staticResources: [mergedSystemResources, mergedBPResources]
    }
  };
  await I18N.init(options);
}